export default "__VITE_ASSET__74208fa7__"